import { Routes, Route, Navigate } from 'react-router-dom';

import Menu from './pages/Menu';
import DishDetails from './pages/DishDetails';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import Profile from './pages/Profile';
import ProfileEditName from './pages/ProfileEditName';
import Addresses from './pages/Addresses';
import Cards from './pages/Cards';
import SettingsPage from './pages/Settings';
import Login from './pages/Login';
import Privacy from './pages/Legal/Privacy';
import Terms from './pages/Legal/Terms';
import OrderStatus from './pages/OrderStatus';
import Favorites from './pages/Favorites';
import Board from './pages/Board';

import { Layout } from './components/Layout';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      {/* Менюборд для ТВ (п.15): публичный, без Layout и авторизации. */}
      <Route path="/board/:id" element={<Board />} />
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/menu" replace />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/menu/:id" element={<DishDetails />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/:id" element={<OrderStatus />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/name" element={<ProfileEditName />} />
            <Route path="/addresses" element={<Addresses />} />
            <Route path="/cards" element={<Cards />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/menu" replace />} />
          </Routes>
        </Layout>
      }/>
    </Routes>
  );
}
